import { Divider, Grid } from '@mui/material';
import React from 'react';
import img from './chirantanlogore.jpg';

function ClinicDetails() {
  return (
    <Grid style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Grid container spacing={2}>
        <Grid container item xs={12}>
          <Grid container item xs={12} alignItems="center">
            <Grid item style={{ marginRight: '20px', marginTop: '25px' }}>
              <img
                src={img}
                alt="Chirantan Dental Clinic Logo"
                style={{ height: '100%', maxWidth: '100%' }}
              />
            </Grid>
            <Grid item xs style={{ display: 'flex', flexDirection: 'column' }}>
              <h2 style={{ marginBottom: '5px' }}>CHIRANTHAN DENTAL CARE</h2>
              <p style={{ margin: '2px 0' }}>4th MAIN, 9th CROSS, P J EXTENSION</p>
              <p style={{ margin: '2px 0' }}>NEAR NANDI NURSING HOME, BEHIND VISWESWARAIAH PARK,</p>
              <p style={{ margin: '2px 0' }}>DAVANGERE, KARNATAKA 577002, +91 9342238439</p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* <Divider style={{width:'5px'}}/> */}
    </Grid>
  );
}

export default ClinicDetails;
